import { useState } from "react";
import { Boton } from "../../components/ui/primitivos";
import { reabrirFacturacionOt } from "../../lib/consola-api";
import { DialogoMotivo } from "./DialogoMotivo";

/**
 * «Reabrir» una OT que no se factura, desde su detalle (ADR 0099 C4).
 *
 * Aislado en su archivo a propósito: ofrecerlo acá además de en la cola está
 * pendiente de confirmación de Pedro. Si no se confirma, se borra este archivo
 * y su uso en `SeccionFacturacionOt`; el worker ya lo permite igual.
 */
export function ReabrirDesdeOt({
  otId,
  numero,
  alCambiar,
}: {
  otId: string;
  numero: string;
  alCambiar: () => Promise<void>;
}) {
  const [abierto, setAbierto] = useState(false);
  return (
    <>
      <Boton variante="secundario" onClick={() => setAbierto(true)}>
        Reabrir
      </Boton>
      <DialogoMotivo
        abierto={abierto}
        titulo={`Reabrir ${numero}`}
        descripcion="La decisión de no facturar se deshace y la OT vuelve a pedir que alguien decida."
        confirmar="Reabrir"
        onCerrar={() => setAbierto(false)}
        onConfirmar={async (motivo) => {
          await reabrirFacturacionOt(otId, motivo);
          await alCambiar();
        }}
      />
    </>
  );
}
